module.exports = __webpack_public_path__ + "static/result-countdown.2e01ea32.gif";